import * as PIXI from "pixi.js";
import {drawRoundedRect} from "../../utils/graphics";
import {Assets} from "pixi.js";
import {app, bgSound, events, gameData} from "../../utils/pixiApp";
import {getDeviceMedia} from "../../utils/sizes";

const textStyle = new PIXI.TextStyle({
    fontSize: 16,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 'bold',
    fill: '#000',
    lineHeight: 24,
})
const text2Style = new PIXI.TextStyle({
    fontSize: 14,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    lineHeight: 20,
    fontWeight: 400,
    fill: 'rgba(0, 0, 0, 0.5)',
    align: 'center',
    wordWrap: true,
    wordWrapWidth: 220
})

const sizes = {
    web: {
        width: 280,
        height: 142
    }
}

export class ErrorBalanceModalComponent extends PIXI.Container {
    constructor() {
        super();
        this.bg = new PIXI.Graphics()
        drawRoundedRect(this.bg, 0, 0, 280, 142, 30);
        this.bg.fill('#FFFFFF')

        this.bg.position.set(- (sizes.web.width / 2), -(sizes.web.height / 2))

        this.text1 = new PIXI.Text({ text: 'ВНИМАНИЕ', style: textStyle });
        this.text1.position.set(sizes.web.width / 2, 32)
        this.text1.anchor.set(.5,.5)
        this.text2 = new PIXI.Text({ text: 'У вас закончились деньги на балансе', style: text2Style });
        this.text2.position.set(sizes.web.width / 2, 78)
        this.text2.anchor.set(.5,.5)

        this.bg.addChild(this.text1, this.text2)
        this.buttonGroup = new PIXI.Graphics().rect(0,0,200, 40);
        this.buttonGroup.pivot.set(.5)
        this.buttonGroup.position.set(sizes.web.width / 2 - 100, sizes.web.height - 20)

        this.noBtn = new PIXI.Sprite(PIXI.Texture.from('cancelBtn'));
        this.noBtn.setSize(100, 40)
        this.yesBtn = new PIXI.Sprite(PIXI.Texture.from('upBalanceBtn'));
        this.yesBtn.setSize(100, 40)
        this.yesBtn.position.set(100, 0)

        this.buttonGroup.addChild(this.noBtn, this.yesBtn)
        this.bg.addChild(this.buttonGroup)

        this.addChild(this.bg)

        this.yesBtn.eventMode = 'static';
        this.noBtn.eventMode = 'static';
        this.yesBtn.cursor = 'pointer'
        this.noBtn.cursor = 'pointer'

        this.yesBtn.on('pointerdown', (e) => {this.onClick(e,'yes')})
        this.noBtn.on('pointerdown', (e) => {this.onClick(e,'no')})

        this.resizeView();

        events.onScreenResizeEvent(() => {
            this.resizeView();
        })
    }

    onHover(_, type) {
        this[type === 'yes' ? 'yesBtn' : 'noBtn'].texture = Assets.get(buttons[type].hover);
    }

    onClick(_, type) {
        if(type === 'yes') {
            window.parent.postMessage(
                JSON.stringify({
                    type: 'REDIRECT',
                    data: { to: '/balance' },
                }),
                '*',
            );
        } else {
            gameData.setGameData('startGame', false)
            gameData.setGameDataByEvent('gameOver', true, false)
            this.emit('IS_OPEN_EVENT', false)
        }
    }
    resizeView() {
        const mediaScreen = getDeviceMedia(app.screen.width)

        if(mediaScreen === 'web') {
            this.scale.set(1)
        } else {
            this.scale.set(.82)
        }
    }

}